import { TreatmentPlan } from "../../domain/treatmentPlan.interface";

/**
 * SIMS-9026 — the plan-level disenrollment-threshold propagation option (FR-2).
 *
 * One flag per PLAN (decision D4) — not per config template and not per threshold field. The
 * scope of an actual change is derived from which field moved, which is SIMS-9028's problem,
 * not a second control here.
 *
 * This rule is pulled out of TreatmentPlanForm so it can be asserted directly. The form itself is
 * ~2,100 lines with a dozen data hooks, so a render test would prove more about the mocks than
 * about the rule.
 *
 * A second rule used to live here — `isPropagationOptionAvailable`, disabling the option on Smart
 * Program plans (the plan-proposed AC5, never in the ticket). Removed 2026-09-17: propagation is
 * only ever offered when a threshold FIELD moves, and a Smart Program plan has none — no
 * configuration templates and no segments, across all 11 such plans on dev — so the control could
 * never fire there regardless. The predicate guarded nothing and cost a programType branch.
 */

/**
 * Resolve the stored option into the form's checkbox state (AC2, AC3).
 *
 * FR-3 is the whole point: a plan saved before this feature has NO stored value, and it must read
 * as future-enrollments-only — today's behaviour — with no backfill and no migration. So absent,
 * null and false are deliberately the same state. A plan that did set it round-trips its choice
 * back into the form (AC3).
 */
export const resolvePropagationOption = (
	plan?: Pick<TreatmentPlan, "propagateThresholdToCurrentEnrollments"> | null,
): boolean => plan?.propagateThresholdToCurrentEnrollments === true;
